import { Button, Card, CircularProgress, Grid, InputLabel } from '@material-ui/core';
import React, { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { UploadImage } from '../../../components';
import { addMitra } from '../../../redux/actions/MitraActions';

const TambahMitra = () => {
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [params, setParams] = useState({
        logo: "",
        logo_preview: "",
        mitra_name: ''
    });
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        addMitra(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = (text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    };
    const handleChangeFoto = (file, path) => {
        setParams((pref) => ({
            ...pref,
            logo: file,
            logo_preview: path
        }));
    };
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Tambah Mitra</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        <ValidatorForm
                            onSubmit={handleFormSubmit}
                            className="w-full"
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <UploadImage
                                        uploadFoto={handleChangeFoto}
                                        label="Unggah Logo Mitra"
                                        preview={
                                            params?.logo_preview
                                        }
                                        required={true}
                                        note={[
                                            'Format SVG dan WEBP diperbolehkan',
                                            '*Ukuran foto 141 x 50'
                                        ]}
                                        formatIcon={true}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel htmlFor="mitra_name" className="mb-4">
                                        Nama{' '}
                                        <span className="text-danger">*</span>
                                    </InputLabel>
                                    <TextValidator
                                        id="mitra_name"
                                        placeholder="Nama"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        name="mitra_name"
                                        value={params.mitra_name || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Nama Mitra terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={2}
                                        justifyContent="flex-end"
                                        className="flex-column-reverse flex-md-row"
                                    >
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                color="primary"
                                                className="text-primary w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                                onClick={() => history.goBack()}
                                            >
                                                Batal
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className="text-white w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                            >
                                                {submit ? (
                                                    <CircularProgress
                                                        color="primary"
                                                        size={25}
                                                    />
                                                ) : (
                                                    'Simpan'
                                                )}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default TambahMitra;
